<article>
    <div class="row g-0">
        <img *ngFor="let img of images; let i = index; trackBy: trackByFn"
        (click)="clickOn(i)"
        [src]="basePath + img.src"
        [alt]="img.alt"
        class="collage__img col-3 col-md-4"
        role="button"
        width="640"
        height="640"
        loading="lazy"
        decoding="async"
        sizes="(max-width: 768px) 33vw, 25vw">
    </div>
</article>
